import { MsMenu as r } from "@sunrise/icons";
import { screenSizeDetection as s, isMounted as m } from "@sunrise/shared";
import { defineComponent as u, computed as i } from "vue";
import { useHeaderStore as c } from "./index4.js";
const M = u({
  name: "MsBurgerMenuBtn",
  components: {
    MsMenu: r
  },
  setup() {
    const t = c(), { isScreenL: e } = s(), o = m(), n = i(() => o.value && !!t.amount && !e.value);
    return {
      isScreenL: e,
      showDot: n,
      isMounted: o
    };
  }
});
export {
  M as default
};
